import styled from "styled-components";
import passengersThemes from "./themes/index.js";
export const PassengersWrapper = styled.div.withConfig({
    displayName: "styled__PassengersWrapper",
    componentId: "sc-de7a7cf2-0"
})`
	${({ theme  })=>passengersThemes[theme.id]?.PassengersWrapper?.()};
`;

//# sourceMappingURL=styled.js.map